"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CustomAttributesEntity_1 = __importDefault(require("./Entity/CustomAttributesEntity"));
var CustomAttributesApi = /** @class */ (function () {
    function CustomAttributesApi(session) {
        this.customAttributesEntity = new CustomAttributesEntity_1.default(session);
    }
    CustomAttributesApi.prototype.getAllCustomAttributes = function (params) {
        return this.customAttributesEntity.getAllCustomAttributes(params);
    };
    CustomAttributesApi.prototype.createCustomAttribute = function (payload) {
        return this.customAttributesEntity.createCustomAttribute(payload);
    };
    CustomAttributesApi.prototype.updateCustomAttribute = function (payload) {
        return this.customAttributesEntity.updateCustomAttribute(payload);
    };
    CustomAttributesApi.prototype.deleteCustomAttribute = function (id) {
        return this.customAttributesEntity.deleteCustomAttribute(id);
    };
    return CustomAttributesApi;
}());
exports.default = CustomAttributesApi;
//# sourceMappingURL=CustomAttributesApi.js.map